import React, { useEffect } from 'react'
import { monitorTreeStore } from 'store';
import Position from 'view/monitor/position';
import { urlSearchParams, setLocal } from 'util/comm';
import { queryVehicleInfoByPlateNo } from 'server/web/vehicle';
import { useIntl } from 'react-intl';
import { message } from 'antd';

interface PositionPageParams {
  token: string
  plateNo: string
}

function PositionPage() {
  const { formatMessage: f } = useIntl()
  useEffect(() => {

    const params = urlSearchParams<PositionPageParams>(decodeURIComponent((window).location.search))

    if (params.token) {
      setLocal('tx_token', params.token)
    }
    queryVehicleDetailByPlateNo(params.plateNo)
  }, [])

  const queryVehicleDetailByPlateNo = async (plateNo: PositionPageParams['plateNo']) => {

    // 通过车牌号 获取车辆ID
    const result = await queryVehicleInfoByPlateNo({ plateNo: plateNo })
    if (result) {
      if (result.data.vehicleId) {
        monitorTreeStore.checkVehicle([result.data.vehicleId], 2)
      } else {
        message.warning(f({ id: 'tx0830001', description: '车辆不存在' }))
      }
    }
  }

  return (
    <div style={ { width: '100%', height: '100%' } }>
      <Position isForeign={ true } />
    </div>
  )
}

export default PositionPage
